module.exports = __webpack_public_path__ + "img/home-line.fe47f5f7.svg";